import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log';
import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import fetchTimeTrackingOptions from '../../services/time-tracking-options';
import {
	FETCH_TIME_TRACKING_OPTIONS,
	fetchTimeTrackingOptionsSuccess,
} from '../../state/actions/time-tracking-options';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(FETCH_TIME_TRACKING_OPTIONS)
		.switchMap(() => fetchTimeTrackingOptions(store))
		.map((timeTrackingOptions: TimeTrackingOptions) =>
			fetchTimeTrackingOptionsSuccess(timeTrackingOptions),
		)
		.catch(() => {
			log.safeErrorWithoutCustomerData(
				'software-reports.velocity-report.failure',
				'Failed to load time tracking options',
			);
			return Observable.empty<never>();
		});
